import Class from './c-modal-test';
import './c-modal-test@';

export default Class;